<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import PasswordInput from '@/components/form/PasswordInput.vue';
  import YellowButton from '@/components/base/YellowButton.vue';

  export default {
    name: 'ResetPasswordDialog',
    components: { YellowButton, PasswordInput },

    props: {
      value: Boolean,
    },

    data: () => ({
      model: {
        password: '',
      },
      success: false,
      title: '',
      errorMessage: '',
      isValid: false,
      showPassword: false,
      resetPasswordCode: null,
      email: '',
      displayName: '',
    }),

    async mounted() {
      try {
        this.resetPasswordCode = this.$route.query.resetPasswordCode;
        this.email = this.$route.query.email;
        this.displayName = this.$route.query.displayName;

        this.$router.replace({ query: null });
        await firebase.auth().verifyPasswordResetCode(this.resetPasswordCode);

        this.success = true;
        this.title = 'Reset Your Password';
      } catch (error) {
        this.success = false;
        this.errorMessage = error.message;
        this.title = 'Reset password link not working';
      }
    },

    methods: {
      closeModal() {
        this.$store.dispatch('changeResetPasswordDialogState', false);
      },
      async submit() {
        try {
          if (this.$refs.form.validate()) {
            await firebase.auth().confirmPasswordReset(this.resetPasswordCode, this.model.password);
            await this.$store.dispatch('sendResetPasswordSuccessEmail', {
              displayName: this.displayName,
              email: this.email,
            });
            await this.$store.dispatch('changeResetPasswordDialogState', false);
          }
        } catch (error) {
          console.error('Error resetting password:', error);
        }
      },
    },
  };
</script>

<template>
  <v-dialog
    v-model="value"
    :fullscreen="$vuetify.breakpoint.xs"
    content-class="outlined-modal reset-password-form"
    max-width="720px"
    transition="dialog-top-transition"
    width="100%"
    @click:outside="closeModal"
    @keydown.esc="closeModal"
  >
    <v-card
      class="outlined-modal-card ma-auto d-flex align-center flex-column position-relative"
      :width="550"
      :max-width="552"
      data-state="open"
      elevation="0"
      style="border-radius: 20px"
    >
      <v-card-title class="pa-0 white--text">
        {{ title }}
      </v-card-title>
      <v-btn class="close-button-white" icon @click="closeModal">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>

      <v-form v-if="success" ref="form" v-model="isValid" class="form w-100 mt-6" @submit.prevent="submit">
        <PasswordInput v-model="model.password" label="New Password" />
        <div class="d-grid mt-6">
          <v-btn class="golden-outlined" type="button" @click="closeModal">Cancel</v-btn>
          <YellowButton type="submit" :disabled="!isValid">Reset Password</YellowButton>
        </div>
      </v-form>
      <div v-else class="white--text text-center font-size-20 font-weight-semi mb-5">
        {{ errorMessage }}
      </div>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
  .formText {
    font-size: 20px !important;
    color: #fff !important;

    i,
    button {
      color: #fff !important;
    }

    input::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #fff !important;
      opacity: 1; /* Firefox */
    }

    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #fff !important;
    }

    input::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #fff !important;
    }
  }

  .formText.v-input--is-focused fieldset {
    border: 1px solid #f8bf1e;
  }

  .formText.v-input--is-focused button {
    color: #f8bf1e !important;
  }

  .formText.v-text-field--outlined.v-input--has-state fieldset {
    border: 2px solid #ff5252;
  }

  .formText.v-input--is-focused i {
    color: #f8bf1e !important;
  }

  .formText.v-text-field--outlined.v-input--has-state i {
    color: #ff5252 !important;
  }

  .d-grid {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
</style>
